import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import moment from 'moment'
import styles from './BookingList.css'
import connectToStores from 'alt-utils/lib/connectToStores'
import FormStore from '../../stores/FormStore'
import FormActions from '../../actions/FormActions'
import BookingStore from '../../stores/BookingStore'
import BookingActions from '../../actions/BookingActions'

import { Booking } from '../index'

function sortDate (a, b) {
  return new Date(a.pickUpTimeStamp) - new Date(b.pickUpTimeStamp)
}

@connectToStores
@CSSModules(styles, { allowMultiple: true })
export default class BookingList extends Component {
  static propTypes = {
    bookings: PropTypes.arrayOf(PropTypes.object),
    showDepartureField: PropTypes.bool
  }
  static defaultProps = {
    bookings: [],
    showDepartureField: false
  }
  static getStores () {
    return [BookingStore, FormStore]
  }
  static getPropsFromStores () {
    return {
      bookings: BookingStore.getState().bookings,
      showDepartureField: FormStore.getState().showDepartureField
    }
  }

  cancelBooking (orderId) {
    BookingActions.removeBooking(orderId)
  }

  sendConfirmation (orderId, email, cb) {
    FormActions.sendConfirmation(orderId, email, cb)
  }

  render () {
    return (
      <section>
        <h1>Bokade bilar</h1>

        {this.props.bookings.length > 0 ?
          this.props.bookings
            .sort(sortDate)
            .filter(booking => moment(booking.pickUpTimeStamp).diff(moment(), 'hours') > -24)
            .map((booking, i) =>
            <Booking
              booking={booking}
              cancelBooking={this.cancelBooking}
              key={`booking_${i}`} 
              sendConfirmation={this.sendConfirmation}
              showDepartureField={this.props.showDepartureField}
            />
          )
        : <div styleName="noBookings"><em>Inga bokningar</em></div>}

      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/BookingList/BookingList.js